/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeeType } from './FeeType';
import {
    FeeTypeFromJSON,
    FeeTypeFromJSONTyped,
    FeeTypeToJSON,
    FeeTypeToJSONTyped,
} from './FeeType';

/**
 * Financial summary for a claim (editable estimate values, policy details, and fee agreement). One per claim.
 * @export
 * @interface ClaimFinancialSummary
 */
export interface ClaimFinancialSummary {
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    claimId: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    companyId: number;
    /**
     * Policy deductible in cents
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    deductibleCents?: number | null;
    /**
     * Replacement Cost Value in cents
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    rcvCents?: number | null;
    /**
     * Total depreciation in cents
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    depreciationCents?: number | null;
    /**
     * Recoverable depreciation in cents
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    recoverableDepreciationCents?: number | null;
    /**
     * Non-recoverable depreciation in cents
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    nonRecoverableDepreciationCents?: number | null;
    /**
     * 
     * @type {FeeType}
     * @memberof ClaimFinancialSummary
     */
    feeType?: FeeType;
    /**
     * Fee percentage (0–100)
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    feePercentage?: number | null;
    /**
     * Flat fee amount in cents
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    flatFeeCents?: number | null;
    /**
     * Actual Cash Value override in cents (RCV - Depreciation if not set)
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    acvCents?: number | null;
    /**
     * Net Claim override in cents (ACV - Deductible if not set)
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    netClaimCents?: number | null;
    /**
     * Net with Recoverable override in cents (Net Claim + Recoverable Depreciation if not set)
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    netWithRecoverableCents?: number | null;
    /**
     * Expected fee override in cents (auto-computed from fee structure if not set)
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    expectedFeeCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimFinancialSummary
     */
    createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof ClaimFinancialSummary
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimFinancialSummary
     */
    readonly updatedAt: Date;
}



/**
 * Check if a given object implements the ClaimFinancialSummary interface.
 */
export function instanceOfClaimFinancialSummary(value: object): value is ClaimFinancialSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ClaimFinancialSummaryFromJSON(json: any): ClaimFinancialSummary {
    return ClaimFinancialSummaryFromJSONTyped(json, false);
}

export function ClaimFinancialSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimFinancialSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'companyId': json['companyId'],
        'deductibleCents': json['deductibleCents'] == null ? undefined : json['deductibleCents'],
        'rcvCents': json['rcvCents'] == null ? undefined : json['rcvCents'],
        'depreciationCents': json['depreciationCents'] == null ? undefined : json['depreciationCents'],
        'recoverableDepreciationCents': json['recoverableDepreciationCents'] == null ? undefined : json['recoverableDepreciationCents'],
        'nonRecoverableDepreciationCents': json['nonRecoverableDepreciationCents'] == null ? undefined : json['nonRecoverableDepreciationCents'],
        'feeType': json['feeType'] == null ? undefined : FeeTypeFromJSON(json['feeType']),
        'feePercentage': json['feePercentage'] == null ? undefined : json['feePercentage'],
        'flatFeeCents': json['flatFeeCents'] == null ? undefined : json['flatFeeCents'],
        'acvCents': json['acvCents'] == null ? undefined : json['acvCents'],
        'netClaimCents': json['netClaimCents'] == null ? undefined : json['netClaimCents'],
        'netWithRecoverableCents': json['netWithRecoverableCents'] == null ? undefined : json['netWithRecoverableCents'],
        'expectedFeeCents': json['expectedFeeCents'] == null ? undefined : json['expectedFeeCents'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ClaimFinancialSummaryToJSON(json: any): ClaimFinancialSummary {
    return ClaimFinancialSummaryToJSONTyped(json, false);
}

export function ClaimFinancialSummaryToJSONTyped(value?: Omit<ClaimFinancialSummary, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'companyId': value['companyId'],
        'deductibleCents': value['deductibleCents'],
        'rcvCents': value['rcvCents'],
        'depreciationCents': value['depreciationCents'],
        'recoverableDepreciationCents': value['recoverableDepreciationCents'],
        'nonRecoverableDepreciationCents': value['nonRecoverableDepreciationCents'],
        'feeType': FeeTypeToJSON(value['feeType']),
        'feePercentage': value['feePercentage'],
        'flatFeeCents': value['flatFeeCents'],
        'acvCents': value['acvCents'],
        'netClaimCents': value['netClaimCents'],
        'netWithRecoverableCents': value['netWithRecoverableCents'],
        'expectedFeeCents': value['expectedFeeCents'],
        'createdBy': value['createdBy'],
    };
}

